import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import * as mySettings from './settings';
import {TranslateService} from "@ngx-translate/core";

declare var window:any;
@Injectable()
export class GlobalService {
    public SYSTEM_URL;
    public API_URL;
    public API_KEY;

    private warningMsgs = {
        'default': 'Are you sure?',
        'deleteWarning': 'Are you sure you want to delete this entry?\n'
        + 'Doing so will permanently delete it.',
        'archiveWarning': 'Are you sure you want to archive this entry?',
        'unarchiveWarning': 'Are you sure you want to unarchive this entry?'
    };
    private userType;
    private reviewerToken;

    constructor(location: Location,
                private translate: TranslateService) {
        this.SYSTEM_URL = window.location.protocol + '//' + window.location.host + '/';
        this.API_URL = this.SYSTEM_URL;

        this.API_KEY = 'Basic 389a31571f68ca0e41f75e03d30b3e30';
        this.userType = sessionStorage.getItem('usertype');
        this.reviewerToken = sessionStorage.getItem('token');
    }

    get defaultPaginationState() {
        return mySettings.defaultPaginationState;
    }

    getWarningMsg(type: string) {
        return this.warningMsgs[type] ? this.warningMsgs[type] : this.warningMsgs['default'];
    }

    paramsToQueryString(params, paramsMapName: string) {
        let output = '';
        if (params) {
            let result = [];
            if (params.page != null) {
                result.push(['page', params.page]);
            }
            if (params.limit != null) {
                result.push(['perPage', params.limit]);
            }
            if (params.sortBy != null) {
                result.push(['sort',
                    params.sortAsc ?
                    this.mapToDB(params.sortBy, paramsMapName) :
                    '!' + this.mapToDB(params.sortBy, paramsMapName)]);
            }
            output =  '?' + result.map(param => param.join('=')).join('&');
            if (params.filters && params.filters.length) {
                output = `${output}&${params.filters.join('&')}`;
            }
        }
        return output;
    }

    mapToDB(param: string, mapName: string): string {
        return mySettings.dbMapping[mapName][param];
    }

    translateLabel(config) {
        if (!config.translateDomain) {
            config.translateDomain = 'misc';
        }
        return this.translate.instant(config.translateDomain + '.' + config.label);
    }

    inTranslationMode(): boolean {
        return (window.TRANSLATION_MODE === 1);
    }

    getTranslateLinkLabel(): string {
        let label = (window.LANG_TRANSLATION_MULTILINGUAL_MODE === 1) ? 'misc.Translate' : 'misc.Edit Text';
        return this.translate.instant(label);
    }

    backToInterviewList() {
        let listURL;
        let tab = sessionStorage.getItem('tab');
        if (this.userType == 'Utilities') {
            listURL = '/interview/review.php?t=' + this.reviewerToken;
        } else {
            listURL = '/students/index.php?s=resource&ss=video_interviews&mode=list&tab=' + tab;
        }
        window.location.href = listURL;
    }
}
